import dayjs from 'dayjs';

import type { PillColor } from '../../../components/pill/Pill';

export type TruckDocumentStatus = 'valid' | 'expiringSoon' | 'expired' | 'missing';

/** A document counts as expiring soon once its expiry date is within three months. */
const EXPIRY_WARNING_MONTHS = 3;

export function getTruckDocumentStatus(expiresAt: Date | string | null | undefined): TruckDocumentStatus {
  if (!expiresAt) {
    return 'missing';
  }

  const expiry = dayjs(expiresAt);
  if (expiry.isBefore(dayjs(), 'day')) {
    return 'expired';
  }
  if (!expiry.isAfter(dayjs().add(EXPIRY_WARNING_MONTHS, 'month'), 'day')) {
    return 'expiringSoon';
  }
  return 'valid';
}

export const TRUCK_DOCUMENT_STATUS_COLOR: Record<TruckDocumentStatus, PillColor> = {
  valid: 'positive',
  expiringSoon: 'warning',
  expired: 'negative',
  missing: 'neutral',
};

/** Worst status first — drives the badge next to the licence plate. */
const SEVERITY: Record<TruckDocumentStatus, number> = {
  expired: 3,
  missing: 2,
  expiringSoon: 1,
  valid: 0,
};

export function isMoreSevere(a: TruckDocumentStatus, b: TruckDocumentStatus): boolean {
  return SEVERITY[a] > SEVERITY[b];
}
